<template lang="pug">
SpoilerItem(:theme="theme")
  template(#spoiler_title)
    slot(name="spoiler_title")
    icon(name="arrow")
  template(#default)
    slot
</template>

<script>
import SpoilerItem from "@chronos/frontend-base/src/components/spoiler/SpoilerItem.vue";

export default {
  name: "Spoiler",
  components: {
    SpoilerItem,
  },
  props: {
    theme: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss">
@import "../style/spoiler";
</style>
